<template>
  <component
    v-if="iconComponent"
    :is="iconComponent"
    v-bind="iconProps"
  />
</template>

<script setup>
import { computed } from 'vue'
import * as LucideIcons from 'lucide-vue-next'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: Number,
    default: null
  },
  strokeWidth: {
    type: Number,
    default: 1.5
  },
  color: {
    type: String,
    default: null
  }
})

const iconComponent = computed(() => {
  if (!props.name) return null
  return LucideIcons[props.name] || null
})

const iconProps = computed(() => {
  const out = {
    'stroke-width': props.strokeWidth,
  }
  if (props.size !== null && props.size !== undefined) out.size = props.size
  if (props.color) out.color = props.color
  return out
})
</script>
